import type { HTMLAttributes } from 'react'
import React from 'react'
import { csx } from '@vtex/admin-ui'

import { StepTitle } from '../../../../components'

export type SummarySectionProps = HTMLAttributes<HTMLDivElement> & {
  title?: string
}

export const SummarySection = ({
  title,
  children,
  ...props
}: SummarySectionProps) => (
  <div
    className={csx({
      marginTop: '$space-8',
      ':not(:last-child)': {
        paddingBottom: '$space-6',
        borderBottom: '$neutral',
      },
    })}
    {...props}
  >
    <StepTitle
      className={csx({
        display: 'flex',
        marginBottom: '$space-5',
        justifyContent: 'space-between',
        alignItems: 'center',
      })}
    >
      {title}
    </StepTitle>
    {children}
  </div>
)
